<section class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <router-outlet></router-outlet>
            </div>
        </div>
</section>